import { PartialReport } from '../partial-report.type';
import { Component, OnInit, Input } from '@angular/core';
import { AppSettings } from '../../../settings';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-partial-report-items]',
  templateUrl: './partial-report-items.component.html',
  styleUrls: ['./partial-report-items.component.scss']
})
export class PartialReportItemsComponent implements OnInit {
  @Input() partialReport: PartialReport;
  currencySuffix: string;

  constructor(
    private _settings: AppSettings
  ) {
    this.currencySuffix = this._settings.getCurrencySuffix(new Date());
   }

  ngOnInit() {
    this.currencySuffix = this._settings.getCurrencySuffix(new Date(this.partialReport.date));
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/partial-report/partial-report-items/partial-report-items.component.ts